import app from 'flarum/forum/app';
import ExternalLinkWarningModal from '../components/ExternalLinkWarningModal';
const TRUSTED_DOMAINS = ['caddyserver.com', 'debian.org', 'docs.docker.com', 'github.com', 'gitlab.com', 'mariadb.org', 'microsoft.com', 'mozilla.org', 'nginx.org', 'nodejs.org', 'php.net', 'postgresql.org', 'python.org', 'ubuntu.com', 'wordpress.org', 'yandex.ru'];
function matchesDomain(host, domain) {
  return host === domain || host.endsWith(`.${domain}`);
}
export function isTrusted(url) {
  const target = new URL(url, window.location.href);
  if (target.origin === window.location.origin) return true;
  return TRUSTED_DOMAINS.some(domain => matchesDomain(target.hostname.toLowerCase(), domain));
}
export function protectExternalLink(anchor) {
  if (anchor.dataset.dcExternalProtected === '1') return;
  const target = new URL(anchor.href, window.location.href);
  if (!['http:', 'https:'].includes(target.protocol) || target.origin === window.location.origin) return;
  anchor.dataset.dcExternalProtected = '1';
  anchor.rel = 'ugc nofollow noopener noreferrer';
  anchor.target = '_blank';
  if (isTrusted(target.href) || app.forum.attribute('devconnectExternalLinkWarningEnabled') === false) return;
  anchor.addEventListener('click', event => {
    if (event.defaultPrevented) return;
    event.preventDefault();
    app.modal.show(ExternalLinkWarningModal, {
      url: target.href
    });
  });
}
flarum.reg.add('devconnect-link-cards', 'forum/service/externalLinkPolicy', {
  isTrusted,
  protectExternalLink
});
flarum.reg.add('devconnect-link-cards', 'forum/service/externalLinkPolicy', { isTrusted: isTrusted,protectExternalLink: protectExternalLink, });